/*/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Autodesk Design Automation team for Inventor
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////

import repo from '../Repository';
import {addError, addLog} from './notificationActions';

export const actionTypes = {
    PROJECT_LIST_UPDATED: 'PROJECT_LIST_UPDATED',
    ACTIVE_PROJECT_UPDATED: 'ACTIVE_PROJECT_UPDATED',
    UPDATE_PROJECT: 'UPDATE_PROJECT',
    ADD_PROJECT: 'ADD_PROJECT',
    ADD_OR_UPDATE_PROJECT: 'ADD_OR_UPDATE_PROJECT'
};

export default actionTypes;

export const updateProjectList = projectList => {
    return {
        type: actionTypes.PROJECT_LIST_UPDATED,
        projectList
    };
};

export const updateActiveProject = activeProjectId => {
    return {
        type: actionTypes.ACTIVE_PROJECT_UPDATED,
        activeProjectId
    };
};

export const updateProject = (activeProjectId, data) => {
    return {
        type: actionTypes.UPDATE_PROJECT,
        activeProjectId, data
    };
};

export const addProject = (newProject) => {
    return {
        type: actionTypes.ADD_PROJECT,
        newProject
    };
};

// eslint-disable-next-line no-unused-vars
export const fetchProjects = () => async (dispatch, getState) => {
    dispatch(addLog('Load Projects invoked'));
    try {
        const data = await repo.loadProjects();
        dispatch(addLog('Load Projects received'));
        dispatch(updateProjectList(data));
    } catch (error) {
        dispatch(addError('Failed to get Project list. (' + error + ')'));
    }
};
*/




/*/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Autodesk Design Automation team for Inventor
/////////////////////////////////////////////////////////////////////

import repo from '../Repository';
import { addError, addLog } from './notificationActions';

export const actionTypes = {
    PROJECT_LIST_UPDATED: 'PROJECT_LIST_UPDATED',
    ACTIVE_PROJECT_UPDATED: 'ACTIVE_PROJECT_UPDATED',
    UPDATE_PROJECT: 'UPDATE_PROJECT',
    ADD_PROJECT: 'ADD_PROJECT',
    ADD_OR_UPDATE_PROJECT: 'ADD_OR_UPDATE_PROJECT',

    // 🔴 NOWE: lokalne usunięcie projektu z listy
    PROJECT_DELETED_LOCAL: 'PROJECT_DELETED_LOCAL'
};

export default actionTypes;

export const updateProjectList = projectList => {
    return {
        type: actionTypes.PROJECT_LIST_UPDATED,
        projectList
    };
};

export const updateActiveProject = activeProjectId => {
    return {
        type: actionTypes.ACTIVE_PROJECT_UPDATED,
        activeProjectId
    };
};

export const updateProject = (activeProjectId, data) => {
    return {
        type: actionTypes.UPDATE_PROJECT,
        activeProjectId,
        data
    };
};

export const addProject = (newProject) => {
    return {
        type: actionTypes.ADD_PROJECT,
        newProject
    };
};

// 🔴 NOWE: akcja do usunięcia projektu tylko z Redux/UI
export const deleteProjectLocal = (projectId) => {
    return {
        type: actionTypes.PROJECT_DELETED_LOCAL,
        projectId
    };
};

// eslint-disable-next-line no-unused-vars
export const fetchProjects = () => async (dispatch, getState) => {
    dispatch(addLog('Load Projects invoked'));
    try {
        const data = await repo.loadProjects();
        dispatch(addLog('Load Projects received'));
        dispatch(updateProjectList(data));
    } catch (error) {
        dispatch(addError('Failed to get Project list. (' + error + ')'));
    }
};
*/


/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Autodesk Design Automation team for Inventor
/////////////////////////////////////////////////////////////////////

import repo from '../Repository';
import { addError, addLog } from './notificationActions';

export const actionTypes = {
    PROJECT_LIST_UPDATED: 'PROJECT_LIST_UPDATED',
    ACTIVE_PROJECT_UPDATED: 'ACTIVE_PROJECT_UPDATED',
    UPDATE_PROJECT: 'UPDATE_PROJECT',
    ADD_PROJECT: 'ADD_PROJECT',
    ADD_OR_UPDATE_PROJECT: 'ADD_OR_UPDATE_PROJECT',

    // 🔴 lokalne usunięcie projektu z listy
    PROJECT_DELETED_LOCAL: 'PROJECT_DELETED_LOCAL',

    // 🔴 NOWE: flaga ładowania listy projektów
    PROJECTS_LOADING: 'PROJECTS_LOADING'
};

export default actionTypes;

export const updateProjectList = projectList => {
    return {
        type: actionTypes.PROJECT_LIST_UPDATED,
        projectList
    };
};

export const updateActiveProject = activeProjectId => {
    return {
        type: actionTypes.ACTIVE_PROJECT_UPDATED,
        activeProjectId
    };
};

export const updateProject = (activeProjectId, data) => {
    return {
        type: actionTypes.UPDATE_PROJECT,
        activeProjectId,
        data
    };
};

export const addProject = (newProject) => {
    return {
        type: actionTypes.ADD_PROJECT,
        newProject
    };
};

// 🔴 akcja do usunięcia projektu tylko z Redux/UI
export const deleteProjectLocal = (projectId) => {
    return {
        type: actionTypes.PROJECT_DELETED_LOCAL,
        projectId
    };
};

// 🔴 NOWE: ustawianie flagi ładowania listy projektów
export const setProjectsLoading = (isLoading) => {
    return {
        type: actionTypes.PROJECTS_LOADING,
        isLoading
    };
};

// eslint-disable-next-line no-unused-vars
export const fetchProjects = () => async (dispatch, getState) => {
    // 🔴 NOWE: włączamy progress
    dispatch(setProjectsLoading(true));
    dispatch(addLog('Load Projects invoked'));
    try {
        const data = await repo.loadProjects();
        dispatch(addLog('Load Projects received'));
        dispatch(updateProjectList(data));
    } catch (error) {
        dispatch(addError('Failed to get Project list. (' + error + ')'));
    } finally {
        // 🔴 NOWE: wyłączamy progress
        dispatch(setProjectsLoading(false));
    }
};
